
// ============================================
// Universele Resizer Hendel - All js
// ============================================
(function () {
    let resizeTimer;
    let lastWidth = $(window).width();
    function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            let nowWidth = $(window).width();
            let crossedBreakpoint = (lastWidth >= 768 && nowWidth < 768) || (lastWidth < 768 && nowWidth >= 768);
            if (crossedBreakpoint) {
                $('.slick-initialized').each(function () {
                    $(this).slick('unslick');
                });

                setTimeout(function () {
                    initAllSliders();
                    initMobileMenuDropdown();
                    initFooterAccordion();
                }, 200);
            }

            lastWidth = nowWidth;
        }, 400);
    }

    $(window).on('resize', handleResize);

    // ============================================
    // Slider Initialization
    // ============================================
    function initAllSliders() {
        let isMobile = $(window).width() < 768;

        // 1. People Benefits Slider (Mobile Only)
        if (isMobile && $(".people-say__benefit-items").length && !$(".people-say__benefit-items").hasClass('slick-initialized')) {
            $('.people-say__benefit-items').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000
            });
        }

        // 2. People Slider (Always)
        if ($('.people-say__items').length && !$('.people-say__items').hasClass('slick-initialized')) {
            $('.people-say__items').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        }

        // 3. Testimonial Items Slider
        if ($('.testimonial__items').length && !$('.testimonial__items').hasClass('slick-initialized')) {
            $('.testimonial__items').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
            });
        }

        // 4. Product Highlight Slider
        if ($('.product-highlight__items').length && !$('.product-highlight__items').hasClass('slick-initialized')) {
            $('.product-highlight__items').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                // dots: true,
            });
        }
    }

    // Arrow button handlers
    $('.people-say__left-arrow').click(function () {
        $(this).closest('.people-say__content').find('.slick-slider').slick('slickPrev');
    });

    $('.people-say__right-arrow').click(function () {
        $(this).closest('.people-say__content').find('.slick-slider').slick('slickNext');
    });

    $('.testimonial__left-arrow').click(function () {
        $(this).closest('.testimonial').find('.slick-slider').slick('slickPrev');
    });

    $('.testimonial__right-arrow').click(function () {
        $(this).closest('.testimonial').find('.slick-slider').slick('slickNext');
    });

    $(document).ready(function () {
        initAllSliders();
    });

})();
// ============================================
// End All after page load
// ============================================




// Thumb Animation
// ============================================
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Scroll Animation
// ============================================
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();


// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 120, delay = 120) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    if ($ele.hasClass("insight")) return; // already revealed, skip
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();

// marquee start


$(".marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

// marquee end


// sales hero marquee start

$(".sales-hero__marquee").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    rtl: true,
});

$(".sponsor__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false
});


// sales hero marquee end


// customer-stories slider start


$('.customer-stories__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },]
});



$(document).on('click', '.customer-stories__item-wrap', function () {
    const $currentWrap = $(this);
    const currentVideo = $currentWrap.find('video').get(0);
    if ($currentWrap.hasClass('is-playing')) {
        currentVideo.pause();
        $currentWrap.removeClass('is-playing');
        return;
    }
    $('.customer-stories__item-wrap.is-playing').each(function () {
        const video = $(this).find('video').get(0);
        video.pause();
        video.currentTime = 0;
        $(this).removeClass('is-playing');
    });
    currentVideo.muted = false;
    currentVideo.play();
    $currentWrap.addClass('is-playing');
});

// customer-stories slider end



// product slider start


$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product__small-items',
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },
    ]
});
$('.product__small-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});


$('.product__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// product slider end









// ============================================
// Accordion 
// ============================================

$(".accordion__title.active")
    .next(".accordion__content")
    .show();

$(".accordion__title").on("click", function (e) {
    e.preventDefault();

    var $this = $(this);
    var $content = $this.next(".accordion__content");

    // stop all running animations (smooth feel)
    $(".accordion__content").stop(true, true);

    $(".accordion__title").not($this).removeClass("active");
    $(".accordion__content").not($content).slideUp(400);

    $this.toggleClass("active");
    $content.slideToggle(400);
});






$(function () {
  // 🔧 EDIT START TIME HERE
  var hours   = 2;
  var minutes = 36;
  var seconds = 18;

  var totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
  var $countdowns = $('em[data-countdown]');

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  function render() {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;

    $countdowns.text(pad(h) + ':' + pad(m) + ':' + pad(s));
  }

  render(); // initial render

  var timer = setInterval(function () {
    if (totalSeconds <= 0) {
      clearInterval(timer);
      $countdowns.text('00:00:00');
      return;
    }

    totalSeconds--;
    render();
  }, 1000);
});


var isChecked = '';
$('.plan-input').on('change', function() {
    isChecked = $('.plan-input-subscribe').is(':checked');
    if(isChecked){
        $('.default-selling-plan').attr('name', 'selling_plan');
        var subPrice = $('.product__variant-input:checked').attr('sub_price');
        var regPrice = $('.product__variant-input:checked').attr('price');
        var pComPrice = $('.product__variant-input:checked').attr('compare_at_price');
        $('.btn-price span').text(subPrice);
        $('.btn-price del').text(pComPrice);
    }else{
        $('.default-selling-plan').attr('name', '');
        var pPrice = $('.product__variant-input:checked').attr('price');
        var pComPrice = $('.product__variant-input:checked').attr('compare_at_price');
        $('.btn-price span').text(pPrice);
        $('.btn-price del').text(pComPrice);
    }
});






$(".product__btn a").on("click", function (e) {
  e.preventDefault();
  formData = $(".sale-product-form").serialize();
  addToCart(formData)
});

function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
      document.dispatchEvent(new CustomEvent('upcart:open'));
      $("body").addClass("upcartPopupShow");
    //   sectionRedering();

    },
    error: function (err) {
      console.log(err);
    },
  });
};

$(".product__variant-input").on("change", function () {
  var price = $(this).attr("price");
  var com_price = $(this).attr("compare_at_price");
  var sub_price = $(this).attr("sub_price");
  var available = $(this).attr("available");
  var has_subscription = $(this).attr("subscription");
  var sub_save_value = $(this).attr("save_amount");
  var variant_id = $(this).val();
  var planId = $(this).attr("sub_plan");
  var save_value = $(this).attr("origin_save_amount");

  $('.the-variant').val(variant_id);
  $('.default-selling-plan').val(planId);

  if (available == 'false') {
    $(".single-product__btn-add").addClass("disabled");
    $('.single-product__btn-add').text('Sold Out');
  } else {
    $(".single-product__btn-add").removeClass("disabled");
    $('.single-product__btn-add').text('Add to Cart');
  }
  if(has_subscription == 'true'){
    $('.product__purchase').removeClass('hide-plans');
    if(isChecked){
        $('.btn-price span').text(sub_price);
        $('.btn-price del').text(com_price);
    $('.default-selling-plan').attr('name', 'selling_plan');
    }else{
        $('.btn-price span').text(price);
        $('.btn-price del').text(com_price);
    $('.default-selling-plan').attr('name', '');
    }
  }else{
    $('.product__purchase').addClass('hide-plans');
    $('.default-selling-plan').attr('name', '');
    $('.btn-price span').text(price);
    $('.btn-price del').text(com_price);
    $('.default-selling-plan').attr('name', '');
  }
  
  
  $('.product__purchase-price-onetime del').text(com_price);
  $('.product__purchase-price-onetime span').text(price);
  $('.product__purchase-price-subscribe span').text(sub_price);
  $('.product__purchase-price-subscribe del').text(com_price);
  $('.product__purchase-save_bg-red').text(sub_save_value);
  $('.product__purchase-save_bg-green').text(save_value);
//   $('.btn-price span').text(price);
//   $('.btn-price del').text(com_price);

  
  // $('.single-product-btn span').text(price);
});





















if ($(Window).width() < 768) {
    $(".trust-bar__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
}


document.querySelectorAll('.subscription-tiers__button').forEach(button => {
    button.addEventListener('click', function () {
        const type = this.getAttribute('data-type');
        document.querySelectorAll('.subscription-tiers__button').forEach(item => {
            item.classList.remove('active');
        });
        this.classList.add('active');
        document.querySelectorAll('.subscription-tiers__tab-item').forEach(tab => {
            tab.classList.remove('active');
        });
        const targetTab = document.querySelector(
            `.subscription-tiers__tab-item[data-type="${type}"]`
        );
        if (targetTab) {
            targetTab.classList.add('active');
        }
    });
});





document.addEventListener('DOMContentLoaded', function () {
    const stickyCta = document.querySelector('.sticky-cta');
    const heroSection = document.querySelector('.subscription-hero');
    const productsSection = document.querySelector('.subscription-products');
    if (!stickyCta) return;
    const sectionsInView = new Set();
    const toggleStickyCta = () => {
        if (sectionsInView.size > 0) {
            stickyCta.classList.add('sticky-cta--hidden');
        } else {
            stickyCta.classList.remove('sticky-cta--hidden');
        }
    };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                sectionsInView.add(entry.target);
            } else {
                sectionsInView.delete(entry.target);
            }
        });
        toggleStickyCta();
    }, {
        threshold: 0.15
    });
    if (heroSection) observer.observe(heroSection);
    if (productsSection) observer.observe(productsSection);
});




if ($('.review-tab__items').length && !$('.review-tab__items').hasClass('slick-initialized')) {
    $('.review-tab__items').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },]
    });
}
$('.review-tab__prev-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review-tab__next-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});

// End Review Tab Slider

// Start Review Tab
$(document).ready(function () {
    $('.review-tab__btn').on('click', function (e) {
        e.preventDefault();
        var tabName = $(this).data('tab');
        $('.review-tab__btn').removeClass('active');
        $(this).addClass('active');
        $('.review-tab__card-box').removeClass('active');
        $('.review-tab__card-box').each(function () {
            if ($(this).attr('tab-content') === tabName) {
                $(this).addClass('active');
            }
        });
    });
});
// End Review Tab

// Start subscription-products Slider
if ($('.subscription-products__items').length && !$('.subscription-products__items').hasClass('slick-initialized')) {
    $('.subscription-products__items').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },]
    });
}

function toggleSubscriptionArrows() {
    $('.subscription-products__items').each(function () {
        var itemCount = $(this).find('.subscription-products__item').length;
        var $arrowsWrapper = $(this).closest('.subscription-products__box').find('.subscription-products__arrows');

        if ($(window).width() > 1024) {
            if (itemCount <= 1) {
                $arrowsWrapper.css('display', 'none');
            } else {
                $arrowsWrapper.css('display', '');
            }
        } else {
            if (itemCount <= 3) {
                $arrowsWrapper.css('display', 'none');
            } else {
                $arrowsWrapper.css('display', '');
            }
        }
    });
}

toggleSubscriptionArrows();
$(window).on('resize', function () {
    toggleSubscriptionArrows();
});

$('.subscription-products__prev-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.subscription-products__next-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});

// End subscription-products Slider

// Start subscription-products Quantity
$(document).on('click', '.subscription-products-card__quantity-plus', function () {
    var $input = $(this).siblings('input');
    var currentVal = parseInt($input.val()) || 1;
    $input.val(currentVal + 1);
});

$(document).on('click', '.subscription-products-card__quantity-minus', function () {
    var $input = $(this).siblings('input');
    var currentVal = parseInt($input.val()) || 1;
    if (currentVal > 1) {
        $input.val(currentVal - 1);
    }
});
// End subscription-products Quantity

// Start subscription-products Tab
$(document).ready(function () {
    $('.subscription-products__btn').on('click', function (e) {
        e.preventDefault();
        var tabName = $(this).data('tab');
        $('.subscription-products__btn').removeClass('active');
        $(this).addClass('active');
        $('.subscription-products__box').removeClass('active');
        $('.subscription-products__box').each(function () {
            if ($(this).attr('tab-content') === tabName) {
                $(this).addClass('active');
            }
        });
    });
});
// End subscription-products Tab













// Start Subscription Tiers Range Bar


jQuery(function ($) {
  const $buttons = $('.subscription-tiers__button');
  const $tabs = $('.subscription-tiers__tab-item');
  const $bar = $('.subscription-tiers__progressbar');
  const $fill = $('.subscription-tiers__progressbar-count');
  const total = $buttons.length;
  if (!total) return;

  const stepPercent = (i) => (total === 1 ? 0 : (i / (total - 1)) * 100);

  let currentIndex = 0;

  function switchTab(index) {
    if (index === currentIndex) return;
    currentIndex = index;
    const type = $buttons.eq(index).attr('data-type');
    $buttons.removeClass('active').eq(index).addClass('active');
    $tabs.removeClass('active');
    $(`.subscription-tiers__tab-item[data-type="${type}"]`).addClass('active');
  }

  function activate(index) {
    index = Math.max(0, Math.min(index, total - 1));
    switchTab(index);
    $fill.css('width', stepPercent(index) + '%');
  }

  function nearestIndex(percent) {
    let idx = 0, min = Infinity;
    for (let i = 0; i < total; i++) {
      const d = Math.abs(percent - stepPercent(i));
      if (d < min) { min = d; idx = i; }
    }
    return idx;
  }

  function percentFromX(clientX) {
    const rect = $bar[0].getBoundingClientRect();
    return Math.max(0, Math.min(((clientX - rect.left) / rect.width) * 100, 100));
  }

  $buttons.on('click', function () {
    activate($buttons.index(this));
  });

  let dragging = false;

  $bar.on('pointerdown', function (e) {
    dragging = true;
    $fill.css('transition', 'none');
    const percent = percentFromX(e.clientX);
    $fill.css('width', percent + '%');
    switchTab(nearestIndex(percent));
    $bar[0].setPointerCapture(e.pointerId);
  });

  $bar.on('pointermove', function (e) {
    if (!dragging) return;
    const percent = percentFromX(e.clientX);
    $fill.css('width', percent + '%');
    switchTab(nearestIndex(percent));
  });

  $bar.on('pointerup pointercancel', function () {
    if (!dragging) return;
    dragging = false;
    $fill.css('transition', '');
  });

  activate($buttons.index($buttons.filter('.active').length ? $buttons.filter('.active') : $buttons.first()));
});

// End Subscription Tiers Range Bar


if ($('body').hasClass('subscription-lp')) {
    $(document).on('click', '.Collapsible', function (e) {
        var $sidebar = $('#sidebar-menu[data-section-id="subscription-sidebar-menu"]');
        if ($sidebar.attr('aria-hidden') === 'false') {
            $sidebar.find('.Drawer__Header button, .Drawer__Close, [data-action="close-drawer"]').first().trigger('click');
        }
    });
}



if ($('.product__big-items.product__big-items_lp').hasClass('slick-initialized')) {
    $('.product__big-items.product__big-items_lp').slick('unslick');
}
if ($('.product__small-items.product__small-items_lp').hasClass('slick-initialized')) {
    $('.product__small-items.product__small-items_lp').slick('unslick');
}
$('.product__big-items.product__big-items_lp').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product__small-items.product__small-items_lp',
});
$('.product__small-items.product__small-items_lp').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product__big-items.product__big-items_lp',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});

$('.product__big-items-slide-left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__big-items-slide-right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




$('.product__mobi-reviews-items , .product__desk-reviews-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
});


// Start Real Story Slider Desktop & Mobile

if ($('.real-story__items').length && !$('.real-story__items').hasClass('slick-initialized')) {
    $('.real-story__items').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },]
    });
}
$('.real-story__prev-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.real-story__next-arrow').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});


// End Real Story Slider Desktop & Mobile


$(document).ready(function($) {
  function checkPackItems() {
    $('.product__inner_lp .product-pack__wrap').each(function() {
      var $wrap = $(this);
      var itemCount = $wrap.find('.product-pack__item').length;
      if (itemCount > 3) {
        $wrap.addClass('product-pack__wrap_two-col');
      } else {
        $wrap.removeClass('product-pack__wrap_two-col');
      }
    });
  }
  checkPackItems();
});


if ($(window).width() < 768) {
    $(".brand-logo__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
}